var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"white--text",attrs:{"to":{ name: 'Home' }}},[_c('v-img',{staticClass:"mt-5",class:{
      'ml-5': _vm.$vuetify.breakpoint.mdAndUp,
      'mx-5': _vm.$vuetify.breakpoint.smAndDown,
    },attrs:{"src":"/images/header-logo-fyf.png"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }